import { render, staticRenderFns } from "./ProgrammingSvg.vue?vue&type=template&id=46c7e2c6&"
import script from "./ProgrammingSvg.vue?vue&type=script&lang=ts&"
export * from "./ProgrammingSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46c7e2c6', component.options)
    } else {
      api.reload('46c7e2c6', component.options)
    }
    module.hot.accept("./ProgrammingSvg.vue?vue&type=template&id=46c7e2c6&", function () {
      api.rerender('46c7e2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/ProgrammingSvg.vue"
export default component.exports